import { Checkbox } from "./Checkbox"

export const CheckboxInput = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, setFieldTouched, handleChange }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => (
  <Checkbox
    label={props.label}
    onChange={handleChange(field.name)}
    value={field.value}
    classes={props.classes}
    inputId={field.name}
    errors={touched[field.name] && [errors[field.name]]}
    onBlur={() => setFieldTouched(field.name)}
    disabled={props.disabled}
    sx={props.sx}
  />
)
